import { createSlice } from '@reduxjs/toolkit';

import { EarlyFeatureCode } from './early-feature.entities';

export interface EarlyFeatureState {
  code: EarlyFeatureCode | '';
}

const initialState: EarlyFeatureState = {
  code: '',
};

export const earlyFeatureSlice = createSlice({
  name: 'earlyFeature',
  initialState,
  reducers: {
    setEarlyFeatureCode(state, action) {
      state.code = action.payload;
    },
  },
});
